/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1167
 */

var r = require(/* 1431 */"./1431/index")
var i = require(/* 1435 */"./1435/index")
module.exports = function (e, t) {
  return e && r(e, i(t))
}
